/* eslint max-len: 0 */
import React from 'react';

export const Arrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0303 0.469727L15.5607 6.00006L10.0303 11.5304L8.96967 10.4697L12.6893 6.75006H0.5V5.25006H12.6893L8.96967 1.53039L10.0303 0.469727Z"
      fill="currentColor"
    />
  </svg>
);
